import styled, { css } from 'styled-components';

export default styled.div`
  background-color: white;
  transition-property: background-color;
  transition-duration: 0.3s;
  transition-timing-function: ease;

  ${props => props.dark && css`
    background-color: ${props.theme.bg2};
  `}
`;
